import { useEffect } from "react";
import { redirectToMobileInstall } from "../utils/affiliateInstallRedirect";
import {
  captureSignupReferrer,
  getInstallAttributionParams,
  getSignupReferrerDomain,
} from "../services/AttributionService";

/** Legacy /install URLs — affiliates should use /?ref= instead. */
export default function InstallRedirectPage() {
  useEffect(() => {
    captureSignupReferrer();
    redirectToMobileInstall(
      window.location.search,
      getSignupReferrerDomain(),
      getInstallAttributionParams(),
    );
  }, []);

  return null;
}
